import { useState, Suspense, lazy, useMemo, useCallback } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import * as urls from "../../utils/URLConst";
import makeRequest from "../../utils/makeRequest";
import EscalationMatrixModal from "../../componants/modal/EscalationMatrixModal";
import InquiryModal from "../../componants/modal/Inquiry/InquiryModal";
import { Button, Card, Col, Row } from "react-bootstrap";
import toastNotify from "../../utils/ToastNotify";
import Loader from "../../componants/loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { handleLoader } from "../../redux/reducers/layout";
import InquiryTicketMdl from "../../componants/modal/InquiryTicketMdl";
import { BiHomeAlt } from "react-icons/bi";
import { Formik, Form } from "formik";
import TextField from "../../componants/textField/TextField";
import SelectField from "../../componants/textField/SelectField";
import TicketListCom from "../support/TicketListCom";

const ProductCard = lazy(() => import('./ProductCard'));

const ProductsInquiry = () => {
  const [escalationMatrixModal, setEscalationMatrixModal] = useState(false);
  const [itemCodeData, setItemCodeData] = useState();
  const [apidata, setApiData] = useState([]);
  const [isProductDtlMdl, setIsProductDtlMdl] = useState(false);
  const [inquiryData, setInquiryData] = useState([]);
  const [isTicketInquiryMdl, setIsTicketInquiryMdl] = useState(false);
  const screenWidth = useSelector((state) => state.layout.currentScreenWidth);
  const dispatch = useDispatch();
  const [ticket, setTicket] = useState([]);
  const navigate = useNavigate();

  const handleIsExcelationMatrixMdl = (data) => {
    setEscalationMatrixModal(!escalationMatrixModal);
    setItemCodeData(data?.ITEM_CD || null);
  }

  const handleIsTicketInquiryMdl = () => {
    setIsTicketInquiryMdl(!isTicketInquiryMdl)
  }

  const handleTicketInquiry = (data) => {
    handleIsTicketInquiryMdl();
    setItemCodeData(data.ITEM_CD);
    setInquiryData(data || null)
  }

  const handleProductDtlMdl = (data) => {
    setIsProductDtlMdl(!isProductDtlMdl);
    setInquiryData(data || null)
  }

  const fetchProductInquiry = useCallback(async () => {
    try {
      dispatch(handleLoader(true));
      const data = {
        FLAG: "A",
      };
      const result = await makeRequest("POST", urls.getProductInquiry, data, {});
      if (result.STATUS === "0") {
        const response = result.RESPONSE;
        setApiData(response);
      } else {
        result.MESSAGE !== "Not found!" && toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }, [])

  async function fetchTicket(val) {
    try {
      dispatch(handleLoader(true));
      const data = {
        TICKET_ID: val?.ticketId || "",
        STATUS_CD: val?.statusValue || "",
        STATUS_TYPE: val?.statusValue || "",
        TICKET_TYPE: "Q"
      };
      const result = await makeRequest("POST", urls.getTicket, data, {});
      if (result.STATUS === "0") {
        const response = result.RESPONSE;
        setTicket(response);
      } else {
        setTicket([]);
        result.MESSAGE !== "Not found!" && toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }

  async function fetchTicketDtl(val) {
    try {
      dispatch(handleLoader(true));
      const data = {
        TICKET_ID: val.TICKET_ID
      };
      const result = await makeRequest("POST", urls.getTicketDtl, data, {});
      if (result.STATUS === "0") {
        const response = result.RESPONSE[0];
        navigate("/product-inquiry/ticket-view", { state: { response: response } });
      } else {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ingore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }

  const updateReadStatus = async (row) => {
    try {
      dispatch(handleLoader(false));

      const data = {
        TICKET_ID: row.TICKET_ID,
      };

      const result = await makeRequest("POST", urls.updateReadStatus, data, {});
      if (result.STATUS === "0") {
        // Ignore Case
      } else {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      dispatch(handleLoader(false));
    }
  };

  // This is run on ticket row click
  const handleClickOnTicketRow = (row) => {
    fetchTicketDtl(row);
    if (row.READ_STATUS !== "Y") {
      updateReadStatus(row);
    }
  }

  useMemo(() => {
    (async () => {
      await fetchTicket();
      await fetchProductInquiry();
    })();
  }, []);

  const [loadedCount, setLoadedCount] = useState(0);

  const handleImageLoad = () => {
    setLoadedCount((prev) => prev + 1);
  };

  return (
    <>
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className="row date-time container-top">
          <div className="col-lg-6 col-md-6 col-6">
            <div className="pb-2">
              <span className="d-none d-md-inline"><BiHomeAlt />&nbsp;</span>
              <NavLink to="/dashboard" className="text-secondary d-none d-md-inline">
                Dashboard /
              </NavLink>
              <span className="navigation-header-text ps-1"> Inquiry</span>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-6"></div>
        </div>

        <div id="Invoice-list">

          <div className="nav-align-top mb-4">
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item">
                <button
                  type="button"
                  className="nav-link active"
                  role="tab"
                  data-bs-toggle="tab"
                  data-bs-target="#navs-top-profile"
                  aria-controls="navs-top-profile"
                  aria-selected="true"
                >
                  New Inquiry
                </button>
              </li>
              <li className="nav-item">
                <button
                  type="button"
                  className="nav-link"
                  role="tab"
                  data-bs-toggle="tab"
                  data-bs-target="#navs-top-home"
                  aria-controls="navs-top-home"
                  aria-selected="false"
                >
                  View Inquiry
                </button>
              </li>
            </ul>

            <div className="tab-content">
              <div
                className="tab-pane fade show active"
                id="navs-top-profile"
                role="tabpanel"
              >
                {apidata.length > 0 &&
                  <Row>
                    {apidata.slice(0, loadedCount + 1).map((items, id) => (
                      <Col md={3} key={id} className={id > 3 ? "mt-3" : id > 0 ? "mt-md-0 mt-3" : ""}>
                        <Suspense>
                          <ProductCard
                            data={items}
                            handleIsExcelationMatrixMdl={handleIsExcelationMatrixMdl}
                            handleIsTicketInquiryMdl={handleIsTicketInquiryMdl}
                            handleTicketInquiry={handleTicketInquiry}
                            handleProductDtlMdl={handleProductDtlMdl}
                            handleImageLoad={handleImageLoad}
                          />
                        </Suspense>
                      </Col>
                    ))}
                  </Row>
                }

                {apidata.length === 0 && (
                  <Card>
                    <div className="d-flex justify-content-center NoData-image">
                      <img
                        src="./assets/images/No-data.jpg"
                        alt=""
                        className="NoData-Size"
                      />
                    </div>
                    <div className="d-flex justify-content-center">
                      <h4 className="mt-3 text-base"> No Product Found </h4>
                    </div>
                  </Card>
                )}
              </div>
              <div
                className="tab-pane fade"
                id="navs-top-home"
                role="tabpanel"
              >
                <Card>
                  <Card.Body>
                    <Formik
                      initialValues={{
                        ticketId: "",
                        statusValue: "",
                        statusLabel: "ALL",
                      }}
                      onSubmit={(values) => fetchTicket(values)}
                    >
                      {({ setFieldValue, values, handleBlur }) => (
                        <Form>
                          <Row>
                            <Col md={3}>
                              <TextField
                                label="Inquiry ID"
                                name="ticketId"
                                id="ticketId"
                                maxLength={15}
                                value={values.ticketId}
                                onChange={(e) => {
                                  const { value } = e.target;
                                  setFieldValue("ticketId", value.toUpperCase());
                                }}
                                onBlur={handleBlur}
                              />
                            </Col>

                            <Col md={3} className="mt-md-0 mt-3">
                              <SelectField
                                name="status"
                                options={[
                                  { value: "", label: 'All' },
                                  { value: "ALL", label: 'All (Not include close)' },
                                  { value: "O", label: 'Open' },
                                  { value: "R", label: 'ReOpen' },
                                  { value: "P", label: 'Pending' },
                                  { value: "I", label: 'InProgress' },
                                  { value: "C", label: 'Close' },
                                ]}
                                value={{ value: values.statusValue, label: values.statusLabel }}
                                placeholder='Status'
                                onChange={(e) => {
                                  setFieldValue("statusValue", e?.value);
                                  setFieldValue("statusLabel", e?.label);
                                }}
                              />
                            </Col>

                            <Col md={3} className="mt-md-0 mt-3">
                              <Button
                                type="submit"
                                variant="primary"
                                className="btn-sm">
                                Search
                              </Button>
                            </Col>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </Card.Body>
                </Card>
                <TicketListCom ticket={ticket} handleClickOnTicketRow={handleClickOnTicketRow} screenWidth={screenWidth} flag="I" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {escalationMatrixModal && (
        <EscalationMatrixModal
          isOpen={escalationMatrixModal}
          handleIsExcelationMatrixMdl={handleIsExcelationMatrixMdl}
          itemCodeData={itemCodeData}
        />
      )}

      {isProductDtlMdl && (
        <InquiryModal
          isOpen={isProductDtlMdl}
          handleProductDtlMdl={handleProductDtlMdl}
          inquiryData={inquiryData}
        />
      )}

      {isTicketInquiryMdl &&
        <InquiryTicketMdl
          isOpen={isTicketInquiryMdl}
          handleIsTicketInquiryMdl={handleIsTicketInquiryMdl}
          itemCodeData={itemCodeData}
          setItemCodeData={setItemCodeData}
          inquiryData={inquiryData}
        />
      }
    </>
  );
};

export default ProductsInquiry;
